import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { URIS } from '../Uris'

import { changeActiveRole, changePassword, checkExport } from '../actions'
import { envConstants } from '../constants'
import { uiHelper } from '../helpers'

import packageJson from '../../package.json'

const initialState = {
  password1: '',
  password2: ''
}

class Settings extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  changeRole(role) {
    this.props.changeActiveRole({ role })
  }

  componentDidUpdate(prevProps, prevState) {
    const p = prevProps.profile
    const c = this.props.profile
    if (p.loading && !c.loading) {
      this.setState({
        ...initialState
      })
    }
  }

  componentDidMount() {
    if (!this.props.exportqueue.list) {
      this.props.checkExport()
    }
  }

  render() {
    const { roles } = this.props.profile
    const { id } = uiHelper.getActiveRole()
    const { list } = this.props.exportqueue
    const s = this.state
    return (
      <div className='full-page'>
        <h1>Impostazioni</h1>
        <h2>Cambia password</h2>
        <ul className='ul-detections'>
          <li className='field'>
            <input
              type='text'
              value={this.state.password1}
              onChange={(event) =>
                this.setState({ password1: event.target.value })
              }
              placeholder='Nuova password'
            />
          </li>
          <li>
            <input
              type='text'
              value={this.state.password2}
              onChange={(event) =>
                this.setState({ password2: event.target.value })
              }
              placeholder='Conferma nuova password'
            />
          </li>
          <li className='btn'>
            <button
              className='lnk-edit-lot'
              onClick={() =>
                this.props.changePassword({ password: this.state.password1 })
              }
              disabled={s.password1 !== s.password2 || s.password1 === ''}
            >
              cambia password
            </button>
          </li>
        </ul>
        <h2>Seleziona ruolo</h2>
        <select
          onChange={(event) => this.changeRole(event.target.value)}
          value={id || 0}
        >
          {(roles || []).map((r, index) => {
            return (
              <option key={index} value={r.id}>
                {r.name}
              </option>
            )
          })}
        </select>
        <h2>Elenco esportazioni</h2>
        {(list || []).map((e, index) => {
          return (
            <ul key={index} className='export-list'>
              <li className='icon'>
                {e.format === 'pdf' && <i className='fas fa-file-pdf'></i>}
                {e.format === 'csv' && <i className='fas fa-file-csv'></i>}
                {e.format === 'xml' && <i className='fas fa-file-code'></i>}
              </li>
              <li className='name'>
                <a
                  href={URIS.file + e.guid + '.' + e.format}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='lnk-gen'
                >
                  {e.name}
                </a>
              </li>
              <li className='date'>
                {moment.unix(e.crdate).format(envConstants.momentFormat)}
              </li>
            </ul>
          )
        })}
        <h2>Release</h2>
        {packageJson.version} - {packageJson.releaseDate}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  changeActiveRole,
  changePassword,
  checkExport
})(Settings)
